export function isExternalUrl(url: string): boolean {
    return (
        url.startsWith('http://') ||
        url.startsWith('https://') ||
        url.startsWith('www.') ||
        url.startsWith('mailto:') ||
        url.startsWith('tel:')
    );
}

/**
 * Prefix internal path with locale segment or return external url unchanged
 *
 * @param path - The path to prefix
 * @param localeSegment - The locale segment to prefix the path with
 * @returns The prefixed path
 */
export function prefixLocalePath(path: string, localeSegment: string): string {
    /** A section mounted at the country root has an empty path, and still needs the locale segment. */
    if (!path) {
        return `/${localeSegment}`;
    }

    if (isExternalUrl(path)) {
        return path.startsWith('www.') ? `https://${path}` : path;
    }

    if (path.startsWith(`/${localeSegment}`)) {
        return path;
    }

    const normalizedPath = path.replace(/^\//, '');
    return `/${localeSegment}/${normalizedPath}`;
}
